import React from 'react';
import { Snackbar, Alert, Portal } from '@mui/material';

interface AirMaskSnackbarProps {
  open: boolean;
  onClose: () => void;
  severity: 'success' | 'error' | 'warning' | 'info';
  message: string;
  autoHideDuration?: number;
}

/**
 * Shared snackbar component that wraps MUI Snackbar + Alert with the common
 * configuration used throughout the app. Rendered via a Portal so it sits above
 * modal stacking contexts.
 */
const AirMaskSnackbar: React.FC<AirMaskSnackbarProps> = ({
  open,
  onClose,
  severity,
  message,
  autoHideDuration = 3000,
}) => (
  <Portal>
    <Snackbar
      open={open}
      autoHideDuration={autoHideDuration}
      onClose={onClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      sx={{ zIndex: 2000 }}
    >
      <Alert severity={severity} onClose={onClose} sx={{ width: '100%' }}>
        {message}
      </Alert>
    </Snackbar>
  </Portal>
);

export default AirMaskSnackbar;
